import React from 'react'
import { formatPrice } from '@@partner:helpers/util'

import './ProductCardPrice.scss'

export interface ProductPriceProps {
  price: number
  oldPrice?: number
  classNamePrefix?: string
}

export default function ProductPrice ({
  price = 0,
  oldPrice = 0,
  classNamePrefix = 'ProductPrice'
}: ProductPriceProps) {
  const discountActive = oldPrice && oldPrice > 0

  if (discountActive) {
    return (
      <div className={classNamePrefix}>
        <span className={`${classNamePrefix}__New`}>{formatPrice(price)}</span>
        <span className={`${classNamePrefix}__Old`}>
          {formatPrice(oldPrice)}
        </span>
      </div>
    )
  }
  else {
    return (
      <span className={`${classNamePrefix}__Num`}>{formatPrice(price)}</span>
    )
  }
}
